import { render, staticRenderFns } from "./care.vue?vue&type=template&id=067a342f&"
import script from "./care.vue?vue&type=script&lang=js&"
export * from "./care.vue?vue&type=script&lang=js&"
import style0 from "./care.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports